export default __webpack_public_path__ + "static/media/babica.7fc73c3b.jpg";